import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const DEFAULT_CURRENCY = "AED";
let cachedCurrency: string | null = null;

export function useCurrency() {
  const [currency, setCurrency] = useState(cachedCurrency || DEFAULT_CURRENCY);

  useEffect(() => {
    if (cachedCurrency) return;
    supabase
      .from("platform_settings")
      .select("value")
      .eq("key", "platform_currency")
      .single()
      .then(({ data }) => {
        const val = data?.value || DEFAULT_CURRENCY;
        cachedCurrency = val;
        setCurrency(val);
      });
  }, []);

  return currency;
}
